export const column = [
  {key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 70},
  {key: '3', headerName: 'OutLet Name', field: 'outlet_name', hide: false, width: 160},
  {key: '4', headerName: 'ORL Name', field: 'outlet_ORL', hide: false, width: 160},
  {key: '5', headerName: 'Audit Number', field: 'audit_id', hide: false, width: 160},
  {key: '6', headerName: 'Audit Agent Name', field: 'agentName', hide: false, width: 160},
  {
    key: '7',
    headerName: 'Submission Date',
    field: 'created_at',
    hide: false,
    width: 150
  },
  {key: '8', headerName: 'Score', field: 'total_mark', hide: false, width: 80},
  {key: '9', headerName: 'Status', field: 'waiting', hide: false, width: 160},
  {key: '11', headerName: 'Aging Days', field: 'agingDays', hide: false, width: 150}
];
